import { Injectable } from "@angular/core";
import { CHttp } from "../core/services/chttp.service";
import { config } from "../app.config";
import { Observable } from "rxjs";
import { Response } from "@angular/http";
import {
  ReferralProgramRequest,
  ReferralRewardRequest,
} from "./referrals.interfaces";

@Injectable()
export class ReferralsService {
  constructor(private http: CHttp) {}

  // Get all referral programs
  public getReferralPrograms(): Observable<Response> {
    return this.http.get(`${config.api_url}referral-programs`);
  }

  // Get a referral program by ID
  public getReferralProgramById(id: string): Observable<Response> {
    return this.http.get(`${config.api_url}referral-programs/${id}`);
  }

  // Create a new referral program
  public createReferralProgram(
    request: ReferralProgramRequest,
  ): Observable<Response> {
    return this.http.post(`${config.api_url}referral-programs`, request);
  }

  // Update a referral program
  public updateReferralProgram(
    id: string,
    request: ReferralProgramRequest,
  ): Observable<Response> {
    return this.http.put(`${config.api_url}referral-programs/${id}`, request);
  }

  // Delete a referral program
  public deleteReferralProgram(id: string): Observable<Response> {
    return this.http.delete(`${config.api_url}referral-programs/${id}`);
  }

  // Archive a referral program
  public archiveReferralProgram(id: string): Observable<Response> {
    return this.http.put(`${config.api_url}referral-programs/${id}/archive`);
  }

  // Get all referral rewards for a program
  public getAllReferralRewards(
    referralProgramId: string,
  ): Observable<Response> {
    return this.http.get(
      `${config.api_url}referral-programs/${referralProgramId}/rewards/all`,
    );
  }

  // Get latest referral rewards for a program
  public getLatestReferralRewards(
    referralProgramId: string,
  ): Observable<Response> {
    return this.http.get(
      `${config.api_url}referral-programs/${referralProgramId}/rewards`,
    );
  }

  // Get a referral reward by ID
  public getReferralRewardById(
    referralProgramId: string,
    rewardId: string,
  ): Observable<Response> {
    return this.http.get(
      `${config.api_url}referral-programs/${referralProgramId}/rewards/${rewardId}`,
    );
  }

  // Create a referral reward for a program
  public createReferralReward(
    referralProgramId: string,
    request: ReferralRewardRequest,
  ): Observable<Response> {
    return this.http.post(
      `${config.api_url}referral-programs/${referralProgramId}/rewards`,
      request,
    );
  }

  // Update a referral reward
  public updateReferralReward(
    referralProgramId: string,
    rewardId: string,
    request: ReferralRewardRequest,
  ): Observable<Response> {
    return this.http.put(
      `${config.api_url}referral-programs/${referralProgramId}/rewards/${rewardId}`,
      request,
    );
  }

  // Delete a referral reward
  public deleteReferralReward(
    referralProgramId: string,
    rewardId: string,
  ): Observable<Response> {
    return this.http.delete(
      `${config.api_url}referral-programs/${referralProgramId}/rewards/${rewardId}`,
    );
  }

  // Get all referrals for a member
  public getReferralsForMemberSuccess(memberId: string): Observable<Response> {
    return this.http.get(`${config.api_url}referrals/${memberId}`);
  }

  public getReferralsForMemberProgress(memberId: string): Observable<Response> {
    return this.http.get(`${config.api_url}referrals/${memberId}/rewards-progress`);
  }

  // Get all referral reward instances for a member
  public getReferralRewardInstancesForMember(
    memberId: string,
  ): Observable<Response> {
    return this.http.get(`${config.api_url}referrals/rewards/${memberId}`);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/referrals/referrals.service.ts